import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class CouponModel extends Component {
    state = {
        item: {},
        errors: {}
    };

    addCoupon = () => {
        this.props
            .addCoupon(this.state.item)
            .then(res => {})
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header couponmentModelHeader">
                        <img src="/images/couponModel.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Add coupon
                    </h2>
                    <div className="modal-body">
                        <div className="form-group m-form__group">
                            <label>Coupon number</label>
                            <input
                                name="code"
                                type="text"
                                onChange={this.onChange}
                                value={this.state.item.code}
                                className="form-control"
                                autocomplete="off"
                                maxlength="8"
                            ></input>
                            {this.state.errors.code ? (
                                <div className="invalid-feedback">
                                    {this.state.errors.code}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.addCoupon}
                        >
                            Add coupon
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideCoupon}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
CouponModel.contextType = AppContext;
export default CouponModel;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/Coupon.js